import React, { useEffect } from 'react';

const HotJarInsert = () => {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const syncStyles = document.createElement('style');
        syncStyles.dataset.hotjarWorkaround = 'true';
        syncStyles.type = 'text/css';

        document.head.insertBefore(syncStyles, document.head.children[0]);

        const isHotjarRecording = () => {
            return (
                window?.hj?.settings?.record ||
                window?.hjSiteSettings?.record ||
                window?._hjSettings?.hjid
            );
        };

        const syncCSSRules = () => {
            const styleElements = document.querySelectorAll('head style');
            if (!styleElements.length) return '';

            let allRules = '';
            styleElements.forEach((element) => {
                if (element.dataset.hotjarWorkaround) return;

                if (!element.sheet) return;

                try {
                    const cssRules = Array.from(element.sheet.cssRules || []);

                    const rulesText = cssRules.map((rule) => rule.cssText).join(' ');

                    allRules += rulesText + ' ';
                } catch (e) {
                    console.warn('Could not access rules for stylesheet', e);
                }
            });

            return allRules;
        };

        let checkInterval = null;
        let lastStyles = '';

        checkInterval = window.setInterval(() => {
            if (!isHotjarRecording()) return;

            window.clearInterval(checkInterval);

            window.setInterval(() => {
                window.requestAnimationFrame(() => {
                    const styles = syncCSSRules();

                    // Only update if styles changed
                    if (styles === lastStyles) return;

                    syncStyles.textContent = styles;
                    lastStyles = styles;
                });
            }, 500);
        }, 50);

        return () => {
            if (checkInterval) window.clearInterval(checkInterval);
        };
    }, []);

    return null;
};

export default HotJarInsert;
